<template>
  <div class="mongo-instanceDatabase-page">
    <Drawer
      :title="slowLogSettingModalTitle"
      v-model="slowLogSettingModal"
      width="500"
      :mask-closable="true"
      @on-close="slowLogSettingCancel">
      <div>
        <Form ref="slowLogSettingForm" :model="slowLogSettingForm" :label-width="60"
                :rules="slowLogSettingRuleValidate">
          <FormItem label="Level" prop="level">
            <Select v-model="slowLogSettingForm.level" clearable filterable>
              <Option :value=0 label="0-不记录任何操作"></Option>
              <Option :value=1 label="1-记录大于 slowms 的操作"></Option>
              <Option :value=2 label="2-记录所有操作"></Option>
            </Select>
          </FormItem>
          <FormItem v-if="slowLogSettingForm.level === 1" label="slowms" prop="slowms">
            <Input type="text" v-model="slowLogSettingForm.slowms" placeholder="" number></Input>
          </FormItem>
          <FormItem>
            <Button type="primary" @click="slowLogSettingSubmit">提交</Button>
            <Button style="margin-left: 8px" @click="slowLogSettingCancel">取消</Button>
          </FormItem>
        </Form>
      </div>
    </Drawer>

    <Card>
      <Row>
        <i-col span="24">
          <h1>{{this.$route.query.name}}</h1>
          <Divider />
        </i-col>
      </Row>
      <Row>
        <Col span="24" :md="18">
          <Form ref="searchForm" inline :model="searchForm" onsubmit="return false;">
            <FormItem prop="name">
              <i-input clearable placeholder="数据库名" v-model="searchForm.name" style="min-width: 200px;" search
                        @on-enter="getDatabase()"></i-input>
            </FormItem>
            <FormItem :label-width="0" class="mob-align-right">
              <Button type="primary" @click="getDatabase()">搜索</Button>
              <Button @click="searchReset()" style="margin-left: 10px;">重置</Button>
            </FormItem>
          </Form>
        </Col>
        <Col span="24" :md="6" class="align-right">
          <Button @click="slowLogSetting()" type="primary" :style="{marginBottom: '10px'}">Profiler设置</Button>
          <Button @click="refresh()" type="primary" :style="{marginBottom: '10px', marginLeft: '10px'}" icon="md-refresh">刷新</Button>
        </Col>
      </Row>
      <tables ref="instanceDatabaseTable" height="600" search-place="top" v-model="instanceDatabaseData"
              :columns="databaseColumns" />
      <Row style="margin: 10px;">
        <div style="float: right;">
          <page :total="count" :current="page" :page-size="size" @on-change="getDatabase"></page>
        </div>
      </Row>
    </Card>
  </div>
</template>

<script>
import Tables from '_c/tables'
import {getDatabaseList, removeDatabase, setProfiler} from '@/api/mongodb'

export default {
  name: 'MongoDBInstanceDatabase',
  components: {
    Tables
  },
  data: function () {
    return {
      searchForm: {
        name: ''
      },
      count: 1,
      size: 15,
      page: 1,
      is_superuser: false,
      dbName: '',
      instanceDatabaseData: [],
      // 慢查设置
      slowLogSettingModal: false,
      slowLogSettingModalTitle: '慢查设置',
      slowLogSettingForm: {
        level: 1,
        slowms: 0
      },
      slowLogSettingRuleValidate: {
        level: [{required: true, trigger: 'blur'}],
        slowms: [{type: 'number', trigger: 'blur'}]
      },
      databaseColumns: [
        { title: '数据库', key: 'name', align: 'center', minWidth: 100 },
        {
          title: 'SIZE',
          key: 'sizeOnDisk',
          align: 'center',
          minWidth: 100,
          render: (h, params) => {
            return h('div', this.formatSizeUnits(params.row.sizeOnDisk))
          }
        },
        { title: 'Profiler Level', key: 'level', align: 'center', minWidth: 150 },
        {
          title: '操作',
          align: 'center',
          minWidth: 150,
          render: (h, params) => {
            if (this.$store.state.user.superuser) {
              return h('div', [
                h('Poptip', {
                  props: {
                    confirm: true,
                    placement: 'bottom',
                    title: '你确定要删除吗?'
                  },
                  on: {
                    'on-ok': () => {
                      this.handleDelete(params.row.name)
                    }
                  }
                }, [
                  h('Button', {
                    props: {
                      type: 'error',
                      size: 'small'
                      // shape: 'circle'
                    },
                    style: {
                      marginRight: '5px'
                    }
                  }, [
                    h('div', '删除')
                  ])
                ])

              ])
            }
          }
        }
      ]
    }
  },
  watch: {
    '$route' (to, from) {
      // 对路由变化作出响应...
      if (this.$route.query.id) {
        this.refresh()
      }
    }
  },
  methods: {
    searchReset () {
      this.searchForm.name = ''
      this.getDatabase()
    },
    refresh () {
      this.getDatabase()
    },
    getDatabase (value = 1) {
      this.page = value
      let params = {
        id: this.$route.query.id,
        page: this.page,
        size: this.size,
        ordering: this.ordering,
        db: this.searchForm.name
      }
      getDatabaseList(params).then(res => {
        this.instanceDatabaseData = res.data.results
        this.count = res.data.count
      }).catch(res => {
        if (res.request) {
          this.$Notice.error({
            title: '获取用户列表失败！请求状态码:' + res.request.status,
            desc: res.request.responseText
          })
        } else {
          this.$Notice.error({
            title: '获取用户列表失败！服务器无响应'
          })
        }
      })
    },

    handleDelete (database) {
      let data = {
        id: this.$route.query.id,
        db: database
      }
      removeDatabase(data).then(res => {
        this.$Notice.success({title: '操作成功！'})
        this.getDatabase()
      }).catch(res => {
        this.$Notice.error({
          title: '操作失败！ 错误状态码:' + res.request.status,
          desc: res.request.responseText
        })
      })
    },

    formatSizeUnits (bytes) {
      if (bytes >= 1073741824) {
        bytes = (bytes / 1073741824).toFixed(2) + ' GB'
      } else if (bytes >= 1048576) {
        bytes = (bytes / 1048576).toFixed(2) + ' MB'
      } else if (bytes >= 1024) {
        bytes = (bytes / 1024).toFixed(2) + ' KB'
      } else if (bytes > 1) {
        bytes = bytes + ' bytes'
      } else if (bytes === 1) {
        bytes = bytes + ' byte'
      } else {
        bytes = '0 bytes'
      }
      return bytes
    },

    slowLogSetting () {
      this.slowLogSettingModal = true
    },

    slowLogSettingCancel () {
      this.slowLogSettingForm.level = 1
      this.slowLogSettingForm.slowms = 0
      this.slowLogSettingModal = false
    },

    slowLogSettingSubmit () {
      let data = {
        id: this.$route.query.id,
        level: this.slowLogSettingForm.level,
        slowms: this.slowLogSettingForm.slowms
      }
      setProfiler(data).then(res => {
        this.$Notice.success({title: '操作成功！'})
        this.getDatabase()
        this.slowLogSettingModal = false
      }).catch(res => {
        this.$Notice.error({
          title: '操作失败！ 错误状态码:' + res.request.status,
          desc: res.request.responseText
        })
      })
    }
  },

  mounted: function () {
    this.getDatabase()
  }
}
</script>
<style lang="less">
@media screen and (max-width:640px) {
  .mongo-instanceDatabase-page {
    h1 {
      font-size: 1.5em;
    }
    .ivu-divider-horizontal {
      margin: 10px 0 15px;
    }
    .tables-edit-outer .tables-edit-con .tables-edit-btn {
      display: block;
    }
  }
}
</style>
